import { ContactDetails, PracticeVertical } from '../../components/onboarding-flow-components/constants';

export enum OnboardingStep {
  Vertical = 'vertical',
  Location = 'location',
  AppointmentType = 'appointmentType',
  Provider = 'provider',
}

export interface VerticalStepData {
  practiceVertical?: PracticeVertical | string;
  industry?: string;
}

export interface LocationStepData {
  locationId: string;
}

export interface AppointmentTypeStepData {
  appointmentTypeId: string;
  appointmentName?: string;
  serviceName?: string;
  duration: number | 'Custom';
  customDuration?: number;
}

export interface ProviderStepData {
  selectedProviderIds: string[];
  firstName?: string;
  lastName?: string;
  contactDetails?: ContactDetails;
}

export interface OnboardingWizardData {
  [OnboardingStep.Vertical]?: VerticalStepData;
  [OnboardingStep.Location]?: LocationStepData;
  [OnboardingStep.AppointmentType]?: AppointmentTypeStepData;
  [OnboardingStep.Provider]?: ProviderStepData;
}
